// extracted by mini-css-extract-plugin
export default {"container":"ojIeyOc","list":"aR_DfXn","listItem":"F28iPnp ZHWKoMf leavesden3"};